import { Effect, Option } from 'effect';

import { applyCartCoupon } from '@vs-shop/engine/module/cart/cartOperations';
import type { OrderItems } from '../../bind/order';
import { createSelectPromotionPayloadFromOrder } from '../../utils/gtm/create/select-promotion';
import { sendGtmEvent } from '../../utils/gtm/gtm';

export type AddCouponToOrderData = {
  couponCode: string;
  orderItems: OrderItems;
};

/** Applies a coupon through Cart and records its selection for GTM. */
export default function addCouponToOrder(data: AddCouponToOrderData) {
  return Effect.gen(function* () {
    const cart = yield* applyCartCoupon({ code: data.couponCode });
    const promotionName = Option.getOrElse(
      Option.flatMap(cart.coupon, (coupon) => coupon.name),
      () => data.couponCode
    );

    yield* createSelectPromotionPayloadFromOrder(
      { id: data.couponCode, name: promotionName },
      data.orderItems
    ).pipe(Effect.flatMap((event) => sendGtmEvent(event, true)));

    return cart;
  });
}
